import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import './index.css'
import Header from '../Header'
import Loading from '../LoadingComponent'
import { Button, TextField, InputAdornment, makeStyles, useMediaQuery } from '@material-ui/core'
import { AuthContext } from '../../App.js'
import { getHostName } from '../../base.js'
import { useSwipeable } from 'react-swipeable'
import COLORS  from '../../colors'
import { isMobile } from 'react-device-detect'
//import { motion } from 'framer-motion'
//import { animationOne, transition } from '../../animations'
 
const useStyles = makeStyles((theme) => ({
	input: {
		//fontColor: COLORS.grey,
		//textAlign: 'left'
	},
	confirmBtn: {
			position: 'relative',
	  	  	backgroundColor: COLORS.blue,
	  	  	fontSize: '1rem',
	  	  	color: '#fff',
	  	  	fontWeight: 'bold',
	  	  	margin: '1rem',
			"&:hover": {
				backgroundColor: COLORS.blue
			} 
	}
}))

const EnterAmount = ({cid}) => {
		const matches = useMediaQuery('(min-width:600px)')
  		const { generateQR, resetCart, setPageNumber, setPrevPage, signOut } = useContext(AuthContext)
		const params = useParams()
		const navigate = useNavigate()
  		const [ amount, setAmount ] = useState(parseFloat('0.00').toFixed(2))
  		const [ keypad, setKeypad ] = useState(false)
  		const [ isDisabled, setIsDisabled ] = useState(true)
		const [ isLoading, setIsLoading ] = useState(true)
  		const [ width, setWidth ] = useState(window.innerWidth);
  		const [ height, setHeight ] = useState(window.innerHeight);
  		const classes = useStyles()

		const currDate = new Date()

		// setup ref for your usage
		const myRef = useRef();
		const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

		const handleLeftSwipe = () => {
				setPageNumber(null)
				setTimeout(() => {
					navigate(`/kekspos/${params.tid}`)
				}, 0) 
		}

		const handleRightSwipe = () => {
				if(!isDisabled){
						resetCart()
						generateQR(amount)
						setTimeout(() => {
								navigate(`/kekspos/${params.tid}/qr-kod`)
						}, 0) 
				}
		}
	
		const refPassthrough = (el) => {
				// call useSwipeable ref prop with el
				handlers.ref(el)
				// set myRef el so you can access it yourself
				myRef.current = el
		}

		const handleQRcode = () => {
				resetCart()
				generateQR(amount)
		}

		useEffect(() => {
			setTimeout(() => setIsLoading(false), 1000) 
			setPrevPage({prevPageNum:1})
			window.addEventListener('popstate', onBackButtonEvent)
		 
			return () => {
					window.removeEventListener('popstate', onBackButtonEvent);
			}
	  	}, [])
		const onBackButtonEvent = (e) => {
				e.preventDefault()
				setPageNumber(null)
				setTimeout(() => {
					navigate(`/kekspos/${params.tid}`)
				}, 0) 	 	 
		}

  		useEffect(()=>{
	  		if(parseFloat(amount)!==0 && amount!=='' && parseInt(amount)<100000){
		  		setIsDisabled(false)
	  		}else{
		  		setIsDisabled(true)
	  		}
  		},[amount])

   		useEffect(()=>{
			function hideKeypad(){
	   			setWidth(window.innerWidth);
	   			setHeight(window.innerHeight);	 	 
   			}
			window.addEventListener('resize', hideKeypad, false)
			return () => window.removeEventListener('resize', hideKeypad, false);
   		},[])
	
		const handleKeyDown = (event) => {
				if(parseFloat(amount)<100000){
					if(event.key>=0 && event.key<=9){
						setAmount((amount*10+parseInt(event.key)*0.01).toFixed(2))
					}else if(event.key==='Backspace'){
						setAmount((Math.floor(amount*10)/100).toFixed(2))
					}
				}else if(event.key==='Backspace'){
						setAmount((Math.floor(amount*10)/100).toFixed(2))
				}
				if(event.key==='Enter'&&!isDisabled){
						resetCart()
						generateQR(amount)
						navigate(`/kekspos/${params.tid}/qr-kod`)
				}
  		}

		useEffect(() => 
		{   
			const handleReload = async (e) => 
			{
				e.preventDefault()
				signOut(cid)
				setTimeout(() => window.location.assign(`/kekspos`, 0));
				window.removeEventListener('beforeunload', handleReload) 			
				return false
			}
	  
			window.addEventListener("beforeunload", handleReload)
			   
			return () => 
			{    
				window.removeEventListener('beforeunload', handleReload) 
			}
		
		}, [])

  if(!isLoading){
  return (
	//<motion.div  initial="out" animate="in" exit="out" variants={animationOne} transition={transition}>
    <div className="amount" {...handlers} ref={refPassthrough}>
    	<Header pageNumber={1} />
	  	<div className="amount-body">
	        <div className="amount-title">UPIŠI IZNOS</div>
	        <div className="amount-input">
	        	<TextField style={{ width:!isMobile?'25rem':'60%', textAlign: 'center'}}
	        	    		inputProps={{style: { fontSize: '1.3rem',
												textAlign: 'right', 
												paddingRight:'0.5rem' }}}
	        	    		label="Iznos"
	                    	variant="outlined"
	                    	type="number"
							InputProps = {{
								className: classes.input,
								endAdornment: (
									<InputAdornment position="start">
										<span style={{color:'#5F6767',
													fontSize:'1.3rem',
													}}>Eur</span>
									</InputAdornment>
								 )
							}}
							onFocus={()=>setKeypad(true)}
							onBlur={()=>setKeypad(false)}
	        	    		value={amount}
							onKeyDown={(event)=>{handleKeyDown(event)}}
	        	/>
	        </div>
	  		{(!keypad||height>500)&&<Button size="large"
			  								component={Link}
											to={`/kekspos/${params.tid}/qr-kod`}
	  	  									variant="contained"
											disabled={isDisabled}
											className={classes.confirmBtn}
											style={{width:!isMobile?'25rem':'90%', top:!matches?'30vh':'30vh', textDecoration:'none'}}
	  	  									onClick={() => handleQRcode()}
	  							>KREIRAJ QR KOD</Button>}
	  	</div>
    </div>
	//</motion.div>
  )
}else{
	return(
		<div>
			<Loading />
		</div>

	)
}
  
}

export default EnterAmount

 